import React from "react";

function Ihub({ ihub }) {
  if (ihub !== "" && ihub.error !== "Data not Found") {
    return (
      <>
        <h2 className="mt-3 ml-3">InvestorsHub Articles</h2>
        <div className="d-flex flex-wrap justify-content-between">
          {ihub.map((data, index) => {
            return (
              <div key={index} className="d-flex flex-col mb-2 my-3 card p-3" style={{ maxWidth: '350px' }}>
                <div className="">
                  <img
                    className="w-50"
                    style={{ height: 50 }}
                    src="https://investorshub.advfn.com/images/ihub-master-logo.png"
                    alt="ihub"
                  />
                </div>
                <div className="flex flex-col mt-3">
                  <div className="d-flex justify-content-between">
                    <span>👤 {data.postAuthor}</span>
                    <span>📅 {data.postDate}</span>
                  </div>
                  <a href={data.postLink} target="_blank" rel="noreferrer">{data.postTitle}</a>
                </div>
              </div>
            );
          })}
        </div>
        <hr></hr>
      </>
    );
  } else {
    return "";
  }
}

function TheLion({ thelion }) {
  if (thelion !== "" && thelion.error !== "Data not Found") {
    return (
      <>
        <h2 className="mt-3 ml-3">The Lion Articles</h2>
        <div className="d-flex flex-wrap justify-content-between">
          {thelion.map((data, index) => {
            return (
              <div key={index} className="d-flex flex-col mb-2 my-3 card p-3" style={{ maxWidth: '350px' }}>
                <div className="">
                  <img
                    className="w-50"
                    style={{ height: 50 }}
                    src="https://www.thelion.com/webimages/forumlogo1.gif"
                    alt="thelion"
                  />
                </div>
                <div className="flex flex-col mt-3">
                  <div className="d-flex justify-content-between">
                    <span>👤 {data.postAuthor}</span>
                    <span>📅 {data.postDate}</span>
                  </div>
                  <a href={data.postLink} target="_blank" rel="noreferrer">{data.postTitle}</a>
                </div>
              </div>
            );
          })}
        </div>
        <hr></hr>
      </>
    );
  } else {
    return "";
  }
}

function Fools({ fools }) {
  if (fools !== "" && fools.error !== "Not Found") {
    return (
      <>
        <h3 className="my-5 ml-3">Fools.com Articles</h3>
        {fools.map((data, index) => {
          return (
            <div className="mb-2 block d-sm-flex" key={index}>
              <img
                src={data.article_image}
                className="col-12 col-sm-3"
                alt={index}
              ></img>
              <div className="col-12 col-sm-5">
                <a href={"https://fool.com" + data.article_link}>
                  <h5>{data.article_header}</h5>
                </a>
                <p>{data.article_desc}</p>
              </div>
            </div>
          );
        })}
      </>
    );
  } else {
    return "";
  }
}


function StockTwits(stocktwits) {
  console.log("STPC", stocktwits.stocktwits.data)
  if (stocktwits.stocktwits.hasOwnProperty('data')) {
    return (
      <div className="p-3">
        <h2 className="my-3">Stock Twits Posts</h2>
        <div className="d-flex flex-wrap">
          {stocktwits.stocktwits.data.map(stock => {
            return (
              <div className="card p-3 mx-2 my-2" style={{ maxWidth: '300px', minWidth: '300px' }}>
                <div className="d-flex align-items-center">
                  <img src={stock.user.avatar_url} className="rounded-circle" alt="stock" />
                  <p className="ml-2 font-weight-bold">{stock.user.name}</p>
                </div>
                <p key={stock.id}>{stock.body}</p>
                {stock.entities.hasOwnProperty('chart') ? (
                  <img src={stock.entities.chart.original} alt="stock" style={{ maxWidth: "100%", maxHeight: "400px" }} />
                ) : ""}
              </div>
            )
          })}
        </div>
      </div>
    )
  } else {
    return "No data"
  }
}

function Boards({ ihub, fools, stocktwits, thelion }) {
  return (
    <div className="bg-light my-5 py-3 px-4">
      <Ihub ihub={ihub} />
      <TheLion thelion={thelion} />
      <StockTwits stocktwits={stocktwits} />
      <Fools fools={fools} />
    </div>
  );
}

export default Boards;
